const cartdata = [
    {
        id:'1',
        img: 'assets/img/food-delivery/cart/th01.jpg',
        title: 'Pizza Pepperoni with Tomatoes',
        size: 'Medium',
        base: 'Standard',
        qty: '1',
        price: '0.00'
    },
    {
        id:'2',
        img: 'assets/img/food-delivery/cart/th02.jpg',
        title: 'Beef Burger with Fries',
        size: 'XL',
        sauce: 'Barbeque',
        qty: '1',
        price: '0.00'
    },
    {
        id:'3',
        img: 'assets/img/food-delivery/cart/th03.jpg',
        title: 'Coca Cola Can, 335ml',
        size: '335ml',
        qty: '1',
        price: '0.00'
    },
]

export { cartdata }
